"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrepaidTransactionHistoryResponseToJSON = exports.PrepaidTransactionHistoryResponseFromJSONTyped = exports.PrepaidTransactionHistoryResponseFromJSON = exports.instanceOfPrepaidTransactionHistoryResponse = void 0;
var runtime_1 = require("../runtime");
var Paging_1 = require("./Paging");
var PrepaidTransaction_1 = require("./PrepaidTransaction");
/**
 * Check if a given object implements the PrepaidTransactionHistoryResponse interface.
 */
function instanceOfPrepaidTransactionHistoryResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfPrepaidTransactionHistoryResponse = instanceOfPrepaidTransactionHistoryResponse;
function PrepaidTransactionHistoryResponseFromJSON(json) {
    return PrepaidTransactionHistoryResponseFromJSONTyped(json, false);
}
exports.PrepaidTransactionHistoryResponseFromJSON = PrepaidTransactionHistoryResponseFromJSON;
function PrepaidTransactionHistoryResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paging': !(0, runtime_1.exists)(json, 'paging') ? undefined : (0, Paging_1.PagingFromJSON)(json['paging']),
        'prepaidTransaction': !(0, runtime_1.exists)(json, 'prepaid_transaction') ? undefined : (json['prepaid_transaction'].map(PrepaidTransaction_1.PrepaidTransactionFromJSON)),
    };
}
exports.PrepaidTransactionHistoryResponseFromJSONTyped = PrepaidTransactionHistoryResponseFromJSONTyped;
function PrepaidTransactionHistoryResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'paging': (0, Paging_1.PagingToJSON)(value.paging),
        'prepaid_transaction': value.prepaidTransaction === undefined ? undefined : (value.prepaidTransaction.map(PrepaidTransaction_1.PrepaidTransactionToJSON)),
    };
}
exports.PrepaidTransactionHistoryResponseToJSON = PrepaidTransactionHistoryResponseToJSON;
